import { create } from 'zustand'
import { DataPlayer } from 'player'

interface Store {
  data: DataPlayer
  setData(i: DataPlayer): void
}
export const useStorePlayer = create<Store>((set, get) => ({
  data: {},
  setData: (newData) => {
    const current = get().data
    set(() => ({
      data: {
        ...current,
        ...newData
      }
    }))
  }
}))
